<template>
  <!-- 隐藏 -->
  <div class="headRight">
    <div class="topa" @mouseover="changeBuy()" @mouseout="mouseOut()" :style="headRightStyle">
      <img src="@/assets/image/huo.png" class="rightHuoImg" />
      <ArrowDialogBoxB :showParty="showBuy"></ArrowDialogBoxB>
      <img src="@/assets/image/goumai.png" class="rightImg" />
      <div class="rightFont">立即购票</div>
    </div>
    <div class="topb" @mouseover="changeActive()" @mouseout="mouseOut()" @click="clickParty()">
      <ArrowDialogBoxA :showParty="showParty"></ArrowDialogBoxA>
      <img src="@/assets/image/dang.png" class="rightImg" />
      <div class="rightFont">党的建设</div>
    </div>
    <div class="topb" @click="clickData()">
      <img src="@/assets/image/sssj.png" class="rightImg" />
      <div class="rightFont">实时数据</div>
    </div>
    <div class="topb" @mouseover="changeKefu()" @mouseout="mouseOut()">
      <ArrowDialogBoxC :showParty="showKefu"></ArrowDialogBoxC>
      <img src="@/assets/image/zxkf.png" class="rightImg" />
      <div class="rightFont">在线客服</div>
    </div>
<!--    <a class="topb" @click="kefuOnline">-->
<!--      <img src="@/assets/image/zxkf.png" class="rightImg" />-->
<!--      <div class="rightFont">在线客服</div>-->
<!--    </a>-->
<!--    <a class="topb" @click="complaint">-->
<!--      <img src="@/assets/image/zxts.png" class="rightImg" />-->
<!--      <div class="rightFont">在线投诉</div>-->
<!--    </a>-->
    <div @click="towailianA" class="topb">
      <img src="@/assets/image/xnly.png" class="rightImg" />
      <div class="rightFont">虚拟旅游</div>
    </div>
    <div @click="togonggao" class="topb">
      <img src="@/assets/image/gonggao.png" class="rightImg" />
      <div class="rightFont">公告</div>
    </div>
    <div @click="clickNational" class="topb">
      <img src="@/assets/image/icon9.png" class="rightImg" />
      <div class="rightFontMore">创建全国文明旅游示范单位专栏</div>
    </div>
    <div @click="changeDataList()" class="topb">
      <img src="@/assets/image/fazhi.png" class="rightImg" />
      <div class="rightFontMore">法治与“旅”同行</div>
    </div>
    <!--  <a onclick="window.open('tencent://message/?uin=948715994');" href="javascript:;">开始</ a> -->
  </div>
</template>

<script>
import ArrowDialogBoxA from "../common/arrowDialogBoxA";
import ArrowDialogBoxB from "../common/arrowDialogBoxB";
import ArrowDialogBoxC from "../common/arrowDialogBoxC";
import { getLinkList } from "@/api/common";
export default {
  name: "HeaderRight",
  components: { ArrowDialogBoxA, ArrowDialogBoxB,ArrowDialogBoxC },
  props: ["showFooter"],
  data() {
    return {
      showParty: false,
      showBuy: false,
      showKefu: false,
      headRightStyle: {
        // marginTop: "8.5vh"  暂时注释
      },
      wailianA: "",
      onlineQQ: "",
      complaintQQ: ""
    };
  },
  watch: {
    showFooter(newName, oldName) {
      newName == true
        ? (this.headRightStyle.marginTop = `${8.5}vh`)
        : (this.headRightStyle.marginTop = `${-2}vh`);
    }
  },
  mounted() {
    this.getInfoFunction();
  },
  methods: {
    changeActive() {
      this.showParty = true;
    },
    changeKefu() {
      this.showKefu = true;
    },
    mouseOut() {
      this.showParty = false;
      this.showBuy = false;
      this.showKefu = false;
    },
    changeBuy() {
      this.showBuy = true;
    },
    clickData() {
      this.$emit("specialtyListFunction", "RealTimeData");
    },
    clickParty() {
      this.$emit("specialtyListFunction", "TabParty");
    },
    // 全国文明旅游
    clickNational() {
      this.$emit("specialtyListFunction", "National");
    },
    // 法治
    changeDataList() {
      this.$emit("specialtyListFunction", "TabFaZhi");
    },
    async getInfoFunction() {
      const { code, data } = await getLinkList();
      if (code == 200) {
        this.wailianA = data[4].url;
        this.onlineQQ = data[2].url;
        this.complaintQQ = data[3].url;
      }
    },
    towailianA() {
      window.open(this.wailianA, "_blank");
    },
    kefuOnline() {
      window.open(`tencent://message/?uin=${this.onlineQQ}`);
    },
    complaint() {
      window.open(`tencent://message/?uin=${this.complaintQQ}`);
    },
    //公告
    togonggao() {
      this.$emit("specialtyListFunction", "NoticeList");
    }
  }
};
</script>

<style scoped>
.headRight {
  width: 4.635vw;
  height: 85.55vh;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 11;
  right: 0px;
  text-align: center;
  cursor: pointer;
}
.headRight .topa {
  display: flex;
  flex-direction: column;
  position: relative;
  /* margin-top: 7.3958vh; */
}
.headRight .topb {
  display: flex;
  flex-direction: column;
  position: relative;
}
.headRight .rightImg {
  width: 4.6296vh;
  height: 4.6296vh;
  margin-left: 1.141667vw;
  margin-top: 2.87vh;
}
.headRight .rightFont {
  font-size: 1.2962vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #000000;
  margin-top: 0.8333vh;
  height: 1.11111vh;
  line-height: 1.11111vh;
}
.headRight .rightFontMore {
  font-size: 1.2962vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #000000;
  /* margin-top: 0.8333vh; */
  /* height: 1.11111vh;
  line-height: 1.11111vh; */
  width: 3vw;
  margin: 0.5333vh auto;
}

.headRight .rightHuoImg {
  width: 0.8854vw;
  height: 2.222vh;
  position: absolute;
  z-index: 11;
  top: 2.037vh;
  left: 2.8645vw;
}
.headRight .rightRmxzImg {
  width: 2.03125vw;
  height: 13.981vh;
  position: absolute;
  z-index: 11;
  left: -2.03125vw;
  top: 25.925vh;
}
.headRight .rightColumnFont {
  font-size: 1.296vh;
  font-weight: 400;
  color: #ffffff;
  position: absolute;
  z-index: 12;
  left: -1.25vw;
  top: 88.888vh;
  margin: 0 auto;
  width: 1.296vh;
}
</style>



// WEBPACK FOOTER //
// src/components/common/headRight.vue